import React, { KeyboardEventHandler, useEffect } from 'react';
import { Typography } from '../../../components/typography/typography';
import CreatableSelect from 'react-select/creatable';

const components = {
  DropdownIndicator: null,
};

interface Option {
  readonly label: string;
  readonly value: string;
}

const createOption = (label: string) => ({
  label,
  value: label,
});

export const CreatableMultiselectInput = ({
  className,
  emails,
  onChange,
  placeholder,
  label,
  caption,
}: {
  className?: string;
  emails?: string[];
  onChange: (newValue: any) => any;
  placeholder: string;
  label?: string;
  caption?: string;
}) => {
  const [value, setValue] = React.useState<readonly Option[]>([]);
  const [inputValue, setInputValue] = React.useState('');

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        setValue((prev) => [...prev, createOption(inputValue)]);
        setInputValue('');
        event.preventDefault();
    }
  };

  const init = () => {
    if (emails) {
      const items = emails;

      setValue([]);
      for (const item of items) {
        setValue((prev) => [...prev, createOption(item)]);
      }
    }
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const values = value.map((element) => element.label);
    onChange(values);
  }, [value]);

  return (
    <div className={`${className}`}>
      <div className="mb-1">
        <span className="font-sans text-sm font-semibold capitalize text-gray-500">{label}</span>
      </div>

      <CreatableSelect
        components={components}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={(newValue) => setValue(newValue)}
        onInputChange={(newValue) => setInputValue(newValue)}
        onKeyDown={handleKeyDown}
        placeholder={
          <>
            <Typography type="text-sm">{placeholder}</Typography>
          </>
        }
        value={value}
      />
      {caption && (
        <Typography type="text-sm" className="text-grey-500">
          {caption}
        </Typography>
      )}
    </div>
  );
};
